import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';

Vue.use(Router)
/* Router Modules */
import manage from './modules/manage'

// store 和 router 之间存在循环依赖（store/modules/permission.js 引用 router，router 通过
// modules/manage.js 又引用回 store），谁先被加载，另一方在这个时间点上可能还没初始化完，
// store.state 这里可能是 undefined，加一层兜底避免直接报错
const online = store && store.state ? store.state.online : true;
// 根据是否为离线地面站加载不同的登录组件
let Login = '';
if (online) {
    Login = () => import('@/views/login')
} else {
    Login = () => import('@/views/login-offline')
}

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    /* {
        path: '/tta',
        name: 'tta',
        hidden: true,
        component: () => import('@/views/tta/tta.vue')
    }, */
    {
        path: '/redirect',
        component: () => import('@/layout'),
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect/index')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('@/views/error-page/401'),
        hidden: true
    },
    {
        path: '/task',
        name: 'task',
        hidden: true,
        component: () => import('@/views/task')
    },
    /* {
        path: '/3D',
        name: '3D',
        hidden: true,
        component: () => import('@/views/3D')
    }, */
    {
        path: '/RTS',
        name: 'RTS',
        hidden: true,
        component: () => import('@/views/RTS')
    },
    {
        path: '/webrtc',
        name: 'webrtc',
        hidden: true,
        component: () => import('@/views/Webrtc')
    },
    {
        path: '/video',
        name: 'videoPage',
        hidden: true,
        component: () => import('@/views/Video')
    },
    {
        path: '/flight-task',
        name: 'flightTask',
        hidden: true,
        component: () => import('@/views/flight-task')
    },
    {
        path: '/edit-route',
        name: 'editRoute',
        hidden: true,
        component: () => import('@/views/edit-route')
    },
    {
        path: '/adaptation-dji',
        name: 'adaptationDji',
        hidden: true,
        component: () => import('@/views/adaptation-dji')
    },
    {
        path: '/tta3d',
        name: 'tta3d',
        hidden: true,
        component: () => import('@/views/tta3d')
    },
    {
        path: '/download-app',
        name: 'downloadApp',
        hidden: true,
        component: () => import('@/views/download-app')
    },
    {
        path: '/robot-dog',
        name: 'RobotDog',
        hidden: true,
        // component: () => import('@/views/robot-dog'),
        component: () => import('@/views/robot-dog-deep'),
        children: [
            {
                path: 'list',
                name: 'RobotDogList',
                component: () => import('@/views/robot-dog-deep/list')
            },
            {
                path: 'monitor/:cpuId',
                name: 'RobotDogMonitor',
                component: () => import('@/views/robot-dog-deep/monitor'),
                props: true
            }
        ]
    },
    {
        path: '/mars3d',
        name: 'Mars3d',
        hidden: true,
        component: () => import('@/views/mars3d')
    },
    {
        path: '/ground-station/:type/:id',
        name: 'GroundStation',
        hidden: true,
        props: true,
        component: () => import('@/views/ground-station')
    },
    manage,
    {
        path: '/safe-campus/user/user-manage',
        name: 'SafeCampus_UserManage',
        hidden: true,
        props: true,
        component: () => import('@/views/safe-campus/user/user-manage')
    },
    {
        path: '/safe-campus/user/user-review',
        name: 'SafeCampus_UserReview',
        hidden: true,
        props: true,
        component: () => import('@/views/safe-campus/user/user-review')
    },
    {
        path: '/safe-campus/history/flight-record',
        name: 'SafeCampus_FlightRecord',
        hidden: true,
        props: true,
        component: () => import('@/views/safe-campus/history/flight-record')
    },

    // 解禁申请
    /* {
        path: '/lift-ban',
        component: () => import('@/layout'),
        redirect: '/lift-ban/index',
        children: [
            {
                path: 'index',
                component: () => import('@/views/lift-ban/index'),
                name: 'LiftBan',
                permission: "liftBan",
                meta: { title: 'noFlyZoneLifted', icon: 'skill', name:'禁飞区解禁申请' },
            }
        ]
    }, */

    // 全局电子围栏（企业版，开发阶段先写死路由，后续改为后端下发）
    /* {
        path: '/global-fence',
        component: () => import('@/layout'),
        redirect: '/global-fence/index',
        children: [
            {
                path: 'index',
                component: () => import('@/views/global-fence/index'),
                name: 'GlobalFence',
                meta: { title: '全局电子围栏', icon: 'electronic-fence' },
            }
        ]
    }, */
    // 越界告警记录（企业版，开发阶段先写死路由，后续改为后端下发）
    {
        path: '/boundary-alarm-detail',
        component: () => import('@/layout'),
        redirect: '/boundary-alarm/index',
        children: [
            {
                path: ':id',
                component: () => import('@/views/boundary-alarm/detail'),
                name: 'BoundaryAlarmDetail',
                meta: { title: '越界告警详情' },
                hidden: true,
                props: true,
            }
        ]
    },
]

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
